export const PRM_HELP = "help"
export const PRM_ACCOUNT = "account"
export const PRM_BILLING = "billing"
export const PRM_GROUP = "group"
export const PRM_PERMISSIONS = "permissions"
export const PRM_ACCOUNT_SETTINGS = "accountSettings"
export const PRM_PROJECT_SETTINGS = "projectSettings"
export const PRM_PROJECT = "project"
export const PRM_TASK = "task"
export const PRM_TEAM = "team"
export const PRM_DRIVE = "drive"
export const PRM_COMMENTS = "comments"

export const PRM_CC_LIBRARY = "ccLibrary"
export const PRM_CC_COMPLIANCE = "ccCompliance"
export const PRM_CC_REVIEW = "ccReview"
export const PRM_CC_REQUIREMENT = "ccRequirement"
export const PRM_CC_REQUIREMENT_REVIEW = "ccRequirementReview"
export const PRM_CC_DRAFTS = "ccDrafts"
export const PRM_CC_RESULTS_PDF = "ccResultsPDF"

export const PRM_LIFECYCLE = "lifecycle"
export const PRM_LIFECYCLE_PERMISSIONS = "lifecyclePermissions"
export const PRM_LIFECYCLE_PHASE_LIST = "lifecyclePhaseList"
export const PRM_LIFECYCLE_POPULATE = "lifecyclePopulate"

export const PRM_QID_COMPANY = "qidCompany"
export const PRM_QID_PRODUCT = "qidProduct"

export const PRM_SIL_DEVICE = "silDevice"
export const PRM_SIL_SUBSYSTEM = "silSubsystem"
export const PRM_SIL_SAFETY_FUNCTION = "silSafetyFunction"
export const PRM_SIL_RESULTS = "silResults"
export const PRM_SIL_RESULTS_PDF = "silResultsPDF"

export const PRM_OKR_SESSION = "okrSession"
export const PRM_OKR_OBJECTIVE_KEY_RESULT = "okrObjectiveKeyResult"

export const PRM_RRS_CATEGORY = "rrsCategory"
export const PRM_RRS_TEMPLATE = "rrsTemplate"

export const PRM_STUDY = "study"
export const PRM_STUDY_SESSION = "studySession"

export const PRM_MARKOV_MODEL = "markovModel"
